import * as ExchangeActionTypes from '../../actiontypes/exchange';

/** ----------------------------------------------------------------------------
 * BAZAAR DIALOG
 -----------------------------------------------------------------------------*/
export const openBazaarDialog = item => ({
  type: ExchangeActionTypes.OPEN_BAZAAR_DIALOG,
  payload: { item },
});

export const closeBazaarDialog = () => ({
  type: ExchangeActionTypes.CLOSE_BAZAAR_DIALOG,
  hasCompletedInteraction: false,
});